import { Action } from '@ngrx/store';
import { CountriesAndCategories, CurrentAdmins, InviteAdmin, AdminRole } from '@app/api/models/api-models';
import { IFaqs } from './../../../../api/models/faq.model';

export enum MainActionTypes {
  GET_COUNTRIES_CATEGORIES_LIST_ATTEMPT = '[Main Actions] Get Countries and Categories Attempt',
  GET_COUNTRIES_CATEGORIES_LIST_SUCCESS = '[Main Actions] Get Countries and Categories Success',

  RESET_INVITE_STATUS = '[Main Actions] Reset Invite Status',

  GET_ADMINS_ATTEMPT = '[Main Actions] Admins List Attempt',
  GET_ADMINS_SUCCESS = '[Main Actions] Admins List Success',
  GET_ADMINS_FAILURE = '[Main Actions] Admins List Failure',

  REQUEST_GMB_ADMIN_ROLE_ATTEMPT = '[Main Actions] Request GMB Admin Role Attempt',
  REQUEST_GMB_ADMIN_ROLE_SUCCESS = '[Main Actions]  Request GMB Admin Role Success',
  REQUEST_GMB_ADMIN_ROLE_FAILURE = '[Main Actions] Request GMB Admin Role Failure',

  GET_FAQS_ATTEMPT = '[Main Actions] Get Faqs Attempt',
  GET_FAQS_SUCCESS = '[Main Actions] Get Faqs Success',
}

export class GetCountriesCategoriesList implements Action {
  readonly type = MainActionTypes.GET_COUNTRIES_CATEGORIES_LIST_ATTEMPT;
}

export class GetCountriesCategoriesListSuccess implements Action {
  readonly type = MainActionTypes.GET_COUNTRIES_CATEGORIES_LIST_SUCCESS;
  constructor(public payload: { list: CountriesAndCategories }) {}
}

export class ResetInviteStatus implements Action {
  readonly type = MainActionTypes.RESET_INVITE_STATUS;
}

export class GetAdminsAttempt implements Action {
  readonly type = MainActionTypes.GET_ADMINS_ATTEMPT;
  constructor(public payload: { establishmentId: string }) {}
}

export class GetAdminsSuccess implements Action {
  readonly type = MainActionTypes.GET_ADMINS_SUCCESS;
  constructor(public payload: { response: CurrentAdmins[] }) {}
}

export class GetAdminsFailure implements Action {
  readonly type = MainActionTypes.GET_ADMINS_FAILURE;
  constructor(public payload?: any) {}
}

export class RequestGMBAdminRoleAttempt implements Action {
  readonly type = MainActionTypes.REQUEST_GMB_ADMIN_ROLE_ATTEMPT;
  constructor(public payload: { request: InviteAdmin; adminRole: AdminRole }) {}
}

export class RequestGMBAdminRoleSuccess implements Action {
  readonly type = MainActionTypes.REQUEST_GMB_ADMIN_ROLE_SUCCESS;
}

export class RequestGMBAdminRoleFailure implements Action {
  readonly type = MainActionTypes.REQUEST_GMB_ADMIN_ROLE_FAILURE;
  constructor(public payload?: any) {}
}

export class GetFaqsAttempt implements Action {
  readonly type = MainActionTypes.GET_FAQS_ATTEMPT;
}

export class GetFaqsSuccess implements Action {
  readonly type = MainActionTypes.GET_FAQS_SUCCESS;
  constructor(public payload?: IFaqs) {}
}

export type MainActions =
  | GetCountriesCategoriesList
  | GetCountriesCategoriesListSuccess
  | ResetInviteStatus
  | GetAdminsAttempt
  | GetAdminsSuccess
  | GetAdminsFailure
  | RequestGMBAdminRoleAttempt
  | RequestGMBAdminRoleSuccess
  | RequestGMBAdminRoleFailure
  | GetFaqsAttempt
  | GetFaqsSuccess;
